<template>
  <div>
    <!-- 跟单记录 -->
    <baseBreadcrumb :page="$t('message.documentaryRecords')" :menu="$t('message.orderForm')" />
    <div class="body">
      <div class="search">
        <!-- 订单号 -->
        <div class="item">
          <el-input :placeholder="$t('message.orderNumber')" v-model="datas.order_sn"></el-input>
        </div>
        <!-- 客户名 -->
        <div class="item">
          <el-input :placeholder="$t('message.userName')" v-model="datas.realname"></el-input>
        </div>
        <!-- 客户ID -->
        <div class="item">
          <el-input :placeholder="$t('message.userID')" v-model="datas.user_id"></el-input>
        </div>
        <!-- 添加人 -->
        <div class="item">
          <el-select v-model="datas.created_by" :placeholder="$t('message.addPeople')" filterable>
            <el-option v-for="item in adminList" :key="item.id" :label="item.realname" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <!-- 筛选 -->
        <div class="item">
          <el-button type="primary" @click="search">
            {{ $t('message.filter') }}
          </el-button>
        </div>
      </div>
      <div class="table">
        <ol>
          <!-- 客户信息 -->
          <li>{{ $t('message.userInfo') }}</li>
          <!-- 订单号 -->
          <li class="flex2">{{ $t('message.orderNumber') }}</li>
          <!-- 番号 -->
          <li class="flex05">{{ $t('message.mash') }}</li>
          <!-- 商品信息 -->
          <li class="flex2">{{ $t('message.commodityInformation') }}</li>
          <!-- 添加人 -->
          <li>{{ $t('message.addPeople') }}</li>
          <!-- 备注时间 -->
          <li>{{ $t('message.remarkTime') }}</li>
          <!-- 备注内容 -->
          <li class="flex2">{{ $t('message.remarkContent') }}</li>
          <!-- 查看详情 -->
          <li>{{ $t('message.lookDetail') }}</li>
        </ol>
        <ul v-for="(item, index) in tableData" :key="index">
          <!-- 客户信息 -->
          <li>
            <div class="template">
              <p>
                <router-link
                  :to="'/user/basicInformation?userID=' + item.user.id + '&encryption=' + $md5(item.user.id + '')"
                  target="_blank" class="a-link">
                  {{ item.user.realname }}
                </router-link>
              </p>
              <p>ID:{{ item.user.id }}</p>
              <p>
                <attributeName :name="item.user.attribute.name" />
              </p>
            </div>
          </li>
          <!-- 订单号 -->
          <li class="flex2">
            <!-- 手机下单标记 -->
            <span v-if="item.from_tool != 1" style="vertical-align: middle;"><img src="@/assets/icon/mobile.png" alt=""
                style="width: 25px;"></span>
            <router-link :to="'/orderDetail?order_sn=' + item.order_sn" target="_blank" class="a-link">{{ item.order_sn
            }}</router-link>
          </li>
          <!-- 番号 -->
          <li class="flex05">{{ item.sorting }}</li>
          <!-- 商品信息 -->
          <li class="flex2">
            <div class="detail">
              <div class="img">
                <el-image style="width: 60px; height: 60px" :src="item.pic" :preview-src-list="[item.pic]">
                </el-image>
              </div>
              <div class="attribute">
                <p v-for="(detail, indexs) in item.detail_y" :key="indexs">
                  {{ detail.key }} : {{ detail.value }}
                </p>
              </div>
            </div>
          </li>
          <!-- 添加人 -->
          <li>{{ item.created_by_admin.realname }}</li>
          <!-- 备注时间 -->
          <li>{{ item.created_at }}</li>
          <!-- 备注内容 -->
          <li class="flex2">
            {{ item.remark }}</li>
          <!-- 查看详情 -->
          <li>
            <div class="to_admin">
              <div class="row" v-for="(to, indexs) in item.to_admin" :key="indexs">
                {{ to.realname }} : <span style="color:#67C23A ;" v-if="to.readed_at">已查看</span><span
                  style="color:#B4272D ;" v-else>未查看</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[100, 50, 20, 10]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      datas: {
        page: 1,
        pageSize: 20
      },
      adminList: [],
      name: JSON.parse(localStorage.getItem('japanUserRoleInfo')).role[0].name,
      tableData: [],
      total: 0
    };
  },
  created() {
    this.accountNumberList()
    this.orderDetailNoticeList()
  },
  methods: {
    accountNumberList() {
      // 获取赔款人
      this.$api.roleApi.accountNumberList({ pageSize: 99999, forSelect: 1 }).then(res => {
        if (this.name.indexOf('一部') != -1) {
          res.data.data = res.data.data.filter(item => {
            if (item.role != false) {
              if (item.role[0].organization.name.indexOf('一部') != -1) {
                return item
              }
            }
          })
        }
        if (this.name.indexOf('二部') != -1) {
          res.data.data = res.data.data.filter(item => {
            if (item.role != false) {
              if (item.role[0].organization.name.indexOf('二部') != -1) {
                return item
              }
            }
          })
        }
        if (this.name.indexOf('三部') != -1) {
          res.data.data = res.data.data.filter(item => {
            if (item.role != false) {
              if (item.role[0].organization.name.indexOf('三部') != -1) {
                return item
              }
            }
          })
        }
        this.adminList = res.data.data
      })
    },
    // 列表
    orderDetailNoticeList() {
      this.$api.orderApi.orderDetailNoticeList(this.datas).then(res => {
        this.tableData = res.data.data
        this.total = res.data.total
        console.log(res);
      })
    },
    search() {
      this.datas.page = 1
      this.orderDetailNoticeList();
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.orderDetailNoticeList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.orderDetailNoticeList();
    },
  }
}
</script>
<style lang='scss' scoped>
.search {
  display: flex;

  .item {
    margin-right: 24px;
  }
}

.table {
  margin: 24px 0;
  position: relative;

  ol {
    position: sticky;
    left: 0;
    top: 0;
  }

  .flex2 {
    flex: 2;
  }

  .flex05 {
    flex: 0.5;
  }

  .template {

    p {
      text-align: center;
    }

  }

  .detail {
    width: 100%;
    display: flex;

    .img {
      width: 60px;
      margin-right: 10px;
    }

    .attribute {
      flex: 1;
    }
  }
}
</style>